// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"979e280da148a8596213","883":"2ea9eb58d5014e0ba25a"}[chunkId] + ".js";
};